module.exports = __webpack_public_path__ + "static/Jeremy Roschelle.e0e8e37e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Jeremy Roschelle.jpg
// module id = 1149
// module chunks = 35783957827783